<template>
  <button
    type="button"
    class="sc-mark"
    :class="{ 'is-on': on }"
    :disabled="disabled"
    :aria-pressed="on"
    :aria-label="ariaLabel"
    @click="$emit('pick')"
  >{{ on ? '☑' : '☐' }}</button>
</template>

<script setup lang="ts">
/* 계약서 문서 안 ☐/☑ — 눌러서 켜고 끄는 체크·선택 마크 */
defineProps<{
  on: boolean
  disabled?: boolean
  ariaLabel?: string
}>()

defineEmits<{
  pick: []
}>()
</script>
